import theme from '@/common/styles/mui-theme';

const authHeaderStyles = {
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    py: theme.spacing(5),
    px: theme.spacing(6),
  },
  logo: {
    width: '173px',
    height: '38px',
    display: 'block',
    flexShrink: 0,
  },
};

export default authHeaderStyles;
